import { useSelector } from "react-redux";
import { format, toZonedTime, fromZonedTime } from "date-fns-tz";

const useDateTime = () => {
  const { timezone } = useSelector((state) => state.login);

  const formatDateTime = ({ date = new Date(), dateformat = "" }) => {
    if (!date) return "";
    const dateObj = date instanceof Date ? date : new Date(date);
    // Check if date is Invalid Date
    if (isNaN(dateObj.getTime())) return "";
    const zoneDate = toZonedTime(dateObj, timezone);
    if (dateformat) {
      return format(zoneDate, dateformat, { timeZone: timezone });
    }
    return zoneDate;
  };

  const dateTimeToTimezone = ({ date = new Date() }) => {
    if (!date) return "";
    const zonefromDate = fromZonedTime(date, timezone);
    return zonefromDate;
  };

  return { formatDateTime, dateTimeToTimezone };
};

export default useDateTime;
